import { render, staticRenderFns } from "./EventManagement.vue?vue&type=template&id=3390a5b3&scoped=true"
import script from "./EventManagement.vue?vue&type=script&lang=js"
export * from "./EventManagement.vue?vue&type=script&lang=js"
import style0 from "./EventManagement.vue?vue&type=style&index=0&id=3390a5b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3390a5b3",
  null
  
)

export default component.exports